import dayjs from 'dayjs'
import { genId } from '@/utils/id'
import { seedTrips } from '@/mock/seed'

export default {
  namespaced: true,
  state: {
    list: seedTrips
  },
  getters: {
    all: state => state.list,
    byId: state => id => state.list.find(t => t.id === id)
  },
  mutations: {
    ADD_TRIP (state, trip) {
      state.list.unshift(trip)
    },
    UPDATE_TRIP (state, { id, patch }) {
      const trip = state.list.find(t => t.id === id)
      if (trip) Object.assign(trip, patch)
    },
    REMOVE_TRIP (state, id) {
      state.list = state.list.filter(t => t.id !== id)
    }
  },
  actions: {
    createTrip ({ commit, dispatch }, form) {
      const id = genId()
      const trip = {
        id,
        name: form.name,
        description: form.description || '',
        destinations: form.destinations || [],
        startDate: form.startDate || null,
        endDate: form.endDate || null,
        coverEmoji: form.coverEmoji || '✈️',
        settlementCurrency: form.settlementCurrency || 'HKD',
        timezone: form.timezone || 'Asia/Hong_Kong',
        tags: form.tags || [],
        ownerId: form.ownerId,
        memberIds: [form.ownerId],
        inviteRequiresApproval: false,
        allowMemberInvite: true,
        manualStartedAt: form.quickStart ? new Date().toISOString() : null,
        manualEndedAt: null,
        createdAt: new Date().toISOString()
      }
      commit('ADD_TRIP', trip)
      dispatch('members/ensureCreatorMember', { tripId: id, memberId: form.ownerId, name: form.ownerName }, { root: true })
      return id
    },
    updateTrip ({ commit }, { id, patch }) {
      commit('UPDATE_TRIP', { id, patch })
    },
    endTripManually ({ commit }, id) {
      commit('UPDATE_TRIP', { id, patch: { manualEndedAt: new Date().toISOString() } })
    },
    deleteTrip ({ commit }, id) {
      commit('REMOVE_TRIP', id)
    },
    transferOwner ({ commit }, { tripId, newOwnerId }) {
      commit('UPDATE_TRIP', { id: tripId, patch: { ownerId: newOwnerId } })
    }
  }
}

// 對應規格書 3.1.2「階段判斷」：有日期時依日期判斷，沒有日期時依第一 / 最後一筆 Moment 判斷。
export function computeTripStage (trip, momentTimes) {
  const now = dayjs()
  if (trip.startDate && trip.endDate) {
    if (now.isBefore(dayjs(trip.startDate), 'day')) return 'planning'
    if (now.isAfter(dayjs(trip.endDate), 'day')) return 'ended'
    return 'traveling'
  }
  if (trip.manualEndedAt) return 'ended'
  if (trip.manualStartedAt || (momentTimes && momentTimes.length)) return 'traveling'
  return 'planning'
}

export const STAGE_LABELS = {
  planning: { text: '規劃中', color: '#5b8def' },
  traveling: { text: '旅行中', color: '#3dbd8c' },
  ended: { text: '已結束', color: '#8c8c8c' }
}
